import { c as _c } from "react/compiler-runtime";
import CommonSelect from "@/components/utils/select/CommonSelect";
import type { SortDirection } from "@/entities/ISort";
import type { XtdhTokensSortField } from "@/hooks/useXtdhTokensQuery";
import { TOKENS_SORT_ITEMS } from "../constants";
interface XtdhTokensControlsProps {
  readonly activeSortField: XtdhTokensSortField;
  readonly activeSortDirection: SortDirection;
  readonly onSortChange: (sort: XtdhTokensSortField) => void;
  readonly isDisabled?: boolean | undefined;
}
export function XtdhTokensControls(t0) {
  const $ = _c(5);
  const {
    activeSortField,
    activeSortDirection,
    onSortChange,
    isDisabled: t1
  } = t0;
  const isDisabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== activeSortDirection || $[1] !== activeSortField || $[2] !== isDisabled || $[3] !== onSortChange) {
    t2 = <section className="tw-flex tw-flex-col tw-gap-3 lg:tw-flex-row lg:tw-items-center lg:tw-justify-between" aria-label="Sort received tokens"><div className="tw-w-full md:tw-w-auto tw-overflow-x-auto horizontal-menu-hide-scrollbar"><CommonSelect items={TOKENS_SORT_ITEMS} activeItem={activeSortField} filterLabel="Sort tokens by" setSelected={onSortChange} sortDirection={activeSortDirection} disabled={isDisabled} fill={false} /></div></section>;
    $[0] = activeSortDirection;
    $[1] = activeSortField;
    $[2] = isDisabled;
    $[3] = onSortChange;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}